import './dialog';

(function($) {
    $.widget("ca.caAlert", $.ca.caDialog, {
        options: {
            showCloseButton: true,
            autoOpen: false,
            resizable: false,
            modal: false,
            title: 'Alert',
            className: '',
            width: '458',
            type: 'error',
            fade: false
        },

        open: function() {
            $.ui.dialog.prototype.open.apply(this, arguments);

            if (this.options.showCloseButton == false) {
                this.element.parents('.ui-dialog').find('.ca-titlebar-close').remove();
            }

            if (this.options.className != undefined && this.options.className) {
                this.element.parents('.ui-dialog').addClass(this.options.className);
            }

            var parentDiv = this.element.parents('.ca-dialog');
            parentDiv.children().addClass('remove-margin ca-alert-dialog-wrapper')
                .css('width', this.options.width - 74);

            var iconBlock = $('<div class="ca-alert-icon-block ca-pro-ui"/>');
            iconBlock.css('height', parentDiv.height());
            if (this.options.type == 'alert') {
                iconBlock.append('<i class="fa fa-check fa-2x"/>');
            } else {
                iconBlock.append('<i class="fa fa-exclamation-triangle fa-2x"/>');
            }
            parentDiv.append(iconBlock);
        },

        destroy: function() {
            $.ui.dialog.prototype.destroy.apply(this, arguments);
        }
    });

    /**
     * @param {string|string[]} messages - a text of an alert dialog
     * @param {string} title - the title of a dialog
     * @param {object} options - a map of option-value pairs to set
     */
    $.caAlert = function(messages, title, options) {
        var noteNum = $('.ca-alert').length;
        var isUnifiedUI = $('.ca-unified-ui-wrapper').length;
        var dialogId = noteNum;
        do {
            dialogId++;
        }
        while ($('#alert-dialog-' + dialogId).length);

        var lastChild = $('.ca-alert-dialog-wrapper').last();
        var dialog = $('<div id="alert-dialog-' + dialogId + '" class="ca-alert ca-pro-ui"></div>').appendTo('body');
        dialog.append('<div class="col-md-12"></div>');

        dialog.caAlert();

        var type = 'error';
        var fade = false;
        var className = '';
        var fadeTimeout = 3000;
        if (options != undefined && options instanceof Object) {
            dialog.caAlert('option', options);
            type = options.type || type;
            fade = options.fade || type == 'alert';
            className = options.className || '';
            fadeTimeout = options.fadeTimeout || fadeTimeout;
        }
        dialog.caAlert('option', 'type', type);
        dialog.caAlert('option', 'className', className + ' ca-dialog-' + type);

        // Setting a new dialog position
        var positionSelector = '.header-area';
        if (!$(positionSelector).length) {
            positionSelector = 'body';
        }

        if (noteNum == 0) {
            options = {
                position: {
                    of: positionSelector,
                    at: 'right top',
                    my: isUnifiedUI ? 'right-139 top+84' : 'right-31 top+62'
                }
            };
        } else {
            options = {
                position: {
                    of: lastChild,
                    at: 'right bottom',
                    my: 'right top+15'
                }
            };
        }
        dialog.caAlert('option', options);

        messages = messages || type;

        if (Array.isArray(messages) || (typeof messages === 'object' && messages !== null)) {
            //if it is array or object
            var ul = $('<ul class="ca-dialog-error-list"/>');
            $.each(messages, function(code, message) {
                ul.append('<li>' + message + '</li>');
            });
            dialog.find('.col-md-12').append(ul);
        } else {
            dialog.find('.col-md-12').append(messages);
        }

        if (title == '') {
            title = type.charAt(0).toUpperCase() + type.slice(1);
        }
        if (title != undefined) {
            dialog.caAlert('option', 'title', title);
            dialog.parents('.ui-dialog').find('.block-title').find('h2').html(title);
        }

        dialog.caAlert('open');

        if (fade) {
            var closeWindow = setTimeout(
                function () {
                    $(dialog).parents('.ca-dialog').fadeOut(
                        fadeTimeout,
                        function () {
                            $(dialog).remove();
                            $.updateDialogsPositions();
                        }
                    );
                },
                fadeTimeout
            );

            $(dialog).parents('.ca-dialog').on('mouseover touchstart', function () {
                    clearTimeout(closeWindow);
                    $(this).stop();
                    $(this).fadeTo("fast", 1.0);
                }
            );
        }

        var closeButton = $(dialog).parents('.ca-dialog').find('.ca-titlebar-close');
        closeButton.on('click', function(){
            $.updateDialogsPositions();
        });

        $(window).on('scroll', function() {
            $.updateDialogsPositions();
        });
    };

    /**
     * @param {string|string[]} messages - a text of an alert dialog
     * @param {string} title - the title of a dialog
     * @param {function} callback - the function to call when an alert dialog is closed
     * @param {object} options - a map of option-value pairs to set
     */
    $.caAlertCallback = function(messages, title, callback, options) {
        $.caAlert(messages, title, options);

        if (callback != undefined && typeof(callback) == "function") {
            $('.ca-alert').last().parents('.ui-dialog').find('.ca-titlebar-close').on('click', callback);
        }
    };

    $.caAlertCloseAll = function() {
        $('.ca-alert').remove();
    };

    $.updateDialogsPositions = function() {
        var prevDialog = '.header-area';
        var isUnifiedUI = $('.ca-unified-ui-wrapper').length;
        if (!$(prevDialog).length) {
            prevDialog = 'body';
        }

        $('.ca-alert').each(function(index, value) {
            var position;
            if (index == 0) {
                position = {
                    of: prevDialog,
                    at: 'right top',
                    my: isUnifiedUI ? 'right-139 top+84' : 'right-31 top+62'
                };
            } else {
                position = {
                    of: prevDialog,
                    at: 'right bottom',
                    my: 'right top+15'
                };
            }
            $(value).caAlert('option', 'position', position);

            prevDialog = $(value).parents('.ca-alert-dialog-wrapper');
        });
    };
})(jQuery);
